<div class="content-with-side-menu">
    <div class="row no-gutters">
        <div class="col-md-auto">
            <app-capacity-report-search-criteria
                hznTestId="capacity-report-filters"
                [filters]="filters"
                [searchForm]="searchForm"
            ></app-capacity-report-search-criteria>
        </div>

        <div class="col">
            @if (!noItems && !isBusy) {
                <div
                    class="row no-gutters top-panel height-60 line-height-40 padding-10"
                >
                    <div class="col">
                        <button
                            class="btn btn-success"
                            bcClick
                            hznTestId="capacity-report-generate"
                            (clicked)="getReport()"
                        >
                            {{ "CapacityReport.Generate" | translate }}
                        </button>
                    </div>
                </div>
            }

            <div>
                <bcu-local-spinner
                    [size]="50"
                    [visible]="isBusy"
                ></bcu-local-spinner>

                <div
                    class="list-group list-group-flush grid"
                    infinite-scroll
                    [infiniteScrollDistance]="0.1"
                    [infiniteScrollThrottle]="300"
                    [infiniteScrollDisabled]="isBusy"
                    (scrolled)="onScroll()"
                >
                    @if (!noItems && !isBusy) {
                        <div
                            class="list-group-item list-group-item-action flex-column align-items-start grid-header"
                        >
                            <div class="row">
                                <div class="col-md-1 col-sm-1 grid-column">
                                    {{
                                        "CapacityReport.ClubHeader" | translate
                                    }}
                                </div>
                                <div class="col-md-3 col-sm-3 grid-column">
                                    {{
                                        "CapacityReport.CampNameHeader"
                                            | translate
                                    }}
                                </div>
                                <div class="col-md-3 col-sm-3 grid-column">
                                    {{
                                        "CapacityReport.SessionNameHeader"
                                            | translate
                                    }}
                                </div>
                                <div class="col-md-2 col-sm-2 grid-column">
                                    {{
                                        "CapacityReport.DateHeader" | translate
                                    }}
                                </div>
                                <div class="col-md-1 col-sm-1 grid-column">
                                    {{
                                        "CapacityReport.TotalCapacityHeader"
                                            | translate
                                    }}
                                </div>
                                <div class="col-md-1 col-sm-1 grid-column">
                                    {{
                                        "CapacityReport.UsedCapacityHedaer"
                                            | translate
                                    }}
                                </div>
                                <div class="col-md-1 col-sm-1 grid-column">
                                    {{
                                        "CapacityReport.UsedCapacityPercentHedaer"
                                            | translate
                                    }}
                                </div>
                            </div>
                        </div>
                    }

                    @for (item of items; track item) {
                        <div
                            class="list-group-item list-group-item-action flex-column align-items-start clickable"
                        >
                            <app-capacity-report-item
                                hznTestId="capacity-report-row"
                                [item]="item"
                            ></app-capacity-report-item>
                        </div>
                    }
                    @if (noItems && !isBusy) {
                        <div class="no-items-info padding-20" hznTestId="capacity-report-no-items">
                            <span>{{
                                "CapacityReport.NoItems" | translate
                            }}</span>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
